import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'disableReportPaymentButton',
})
export class DisableReportPaymentButtonPipe implements PipeTransform {
  constructor() {}

  /**
   * Determines if the Payment button should be disabled
   *
   * @returns {boolean} True if the button should be disabled
   */
  transform(
    isSuccessfulContact: boolean,
    isIDVStatusValid: boolean,
    paymentRequirementNotifications: string[],
    isThirdPartyPanel: boolean
  ): boolean {
    return (
      !isSuccessfulContact ||
      !isIDVStatusValid ||
      (paymentRequirementNotifications &&
        paymentRequirementNotifications?.length > 0) ||
      isThirdPartyPanel
    );
  }
}
